import { combineReducers } from "redux"
import { Type } from "../actions/gamecenter"
import dayjs from "dayjs"

const shallowEqual = (a, b) => {
  if (a === b) return true
  if (!a || !b) return false
  const ak = Object.keys(a)
  if (ak.length !== Object.keys(b).length) return false
  for (const k of ak) if (a[k] !== b[k]) return false
  return true
}

const mergeFixtureList = (oldList, newList) => {
  if (!oldList || oldList.length === 0) return newList
  const oldByID = new Map(oldList.map((f) => [f.fixtureId, f]))
  let sameAsOld = oldList.length === newList.length
  const merged = newList.map((f, i) => {
    const old = oldByID.get(f.fixtureId)
    if (old && shallowEqual(old, f)) {
      if (oldList[i] !== old) sameAsOld = false
      return old
    }
    sameAsOld = false
    return f
  })
  return sameAsOld ? oldList : merged
}

function inRunningFixturesLoading(state = false, action) {
  switch (action.type) {
    case Type.FETCH_IN_RUNNING_FIXTURES:
      return true
    case Type.FETCH_IN_RUNNING_FIXTURES_SUCCEEDED:
    case Type.FETCH_IN_RUNNING_FIXTURES_FAILED:
      return false
    default:
      return state
  }
}

function inRunningFixtures(state = { list: [], ccy: "EUR" }, action) {
  switch (action.type) {
    case Type.FETCH_IN_RUNNING_FIXTURES_SUCCEEDED: {
      const mergedList = mergeFixtureList(state.list, action.response.list || [])
      if (mergedList === state.list && state.ccy === action.response.ccy) {
        return state
      }
      return { ...action.response, list: mergedList }
    }
    default:
      return state
  }
}

function matrixLoading(state = false, action) {
  switch (action.type) {
    case Type.FETCH_MATRIX:
      return true
    case Type.FETCH_MATRIX_SUCCEEDED:
    case Type.FETCH_MATRIX_FAILED:
      return false
    default:
      return state
  }
}

function matrix(state = { matrices: [], ccy: "EUR" }, action) {
  switch (action.type) {
    case Type.FETCH_MATRIX:
      return {
        ...state,
        fixtureId: action.fixtureId,
      }
    case Type.FETCH_MATRIX_SUCCEEDED:
      return {
        ...action.response,
        fixtureId: action.fixtureId,
      }
    case Type.HIDE_MATRIX:
      return { matrices: [], ccy: "EUR" }
    default:
      return state
  }
}

function showMatrix(state = false, action) {
  switch (action.type) {
    case Type.SHOW_MATRIX:
      return true
    case Type.HIDE_MATRIX:
      return false
    default:
      return state
  }
}

function matrixFromBrowse(state = false, action) {
  switch (action.type) {
    case Type.SHOW_MATRIX:
      return action.fromBrowse
    case Type.HIDE_MATRIX:
      return false
    default:
      return state
  }
}

function backgroundRefresh(state = false, action) {
  switch (action.type) {
    case Type.START_BACKGROUND_REFRESH:
      return true
    case Type.STOP_BACKGROUND_REFRESH:
      return false
    default:
      return state
  }
}

function browseLoading(state = false, action) {
  switch (action.type) {
    case Type.FETCH_BROWSE:
      return true
    case Type.FETCH_BROWSE_SUCCEEDED:
    case Type.FETCH_BROWSE_FAILED:
      return false
    default:
      return state
  }
}
const defaultBrowse = { list: [], ccy: "EUR" }
function browse(state = defaultBrowse, action) {
  switch (action.type) {
    case Type.FETCH_BROWSE_SUCCEEDED:
      return action.response
    case Type.FETCH_BROWSE_FAILED:
      return defaultBrowse
    default:
      return state
  }
}

let defaultWidgetData = {
  home: {},
  away: {},
  trends: [],
  events: [],
  ccy: "EUR",
}

function widgetData(state = defaultWidgetData, action) {
  switch (action.type) {
    case Type.FETCH_WIDGET_DATA_SUCCEEDED:
      return {
        ...action.response,
        fixtureId: action.fixtureId,
      }
    default:
      return state
  }
}

function browseRange(
  state = {
    from: dayjs().startOf("day").valueOf(),
    to: dayjs().endOf("day").valueOf(),
  },
  action,
) {
  switch (action.type) {
    case Type.FETCH_BROWSE:
      return { from: action.from, to: action.to, sport: action.sport }
    default:
      return state
  }
}

function browseOnlyWithOrders(state = true, action) {
  switch (action.type) {
    case Type.TOGGLE_ONLY_WITH_ORDERS:
      return !state
    default:
      return state
  }
}

function selectedAccountNames(state = [], action) {
  switch (action.type) {
    case Type.SET_SELECTED_ACCOUNT_NAMES:
      return action.accountNames
    default:
      return state
  }
}

function matrixTimestamp(state = Date.now(), action) {
  switch (action.type) {
    case Type.SET_MATRIX_TIMESTAMP:
      return action.timestamp
    case Type.HIDE_MATRIX:
      return Date.now()
    default:
      return state
  }
}

const reducer = combineReducers({
  inRunningFixtures,
  inRunningFixturesLoading,
  matrix,
  matrixLoading,
  showMatrix,
  matrixFromBrowse,
  backgroundRefresh,
  browseLoading,
  browse,
  widgetData,
  browseRange,
  browseOnlyWithOrders,
  selectedAccountNames,
  matrixTimestamp,
})

export default reducer